// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "color": {
      "column": {
        "default": null,
        "name": "color",
        "null": true,
        "type": "string"
      },
      "name": "color",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "icon": {
      "column": {
        "default": null,
        "name": "icon",
        "null": true,
        "type": "string"
      },
      "name": "icon",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "secondary_color": {
      "column": {
        "default": null,
        "name": "secondary_color",
        "null": true,
        "type": "string"
      },
      "name": "secondary_color",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "ScoreFactor",
  "collectionKey": "score_factors",
  "collectionName": "score_factors",
  "i18nKey": "score_factor",
  "camelizedLower": "scoreFactor",
  "name": "ScoreFactor",
  "nameDasherized": "score-factor",
  "pluralName": "score_factors",
  "ransackable_associations": [
    {
      "className": "ScoreFactor::Audit",
      "collectionName": "score_factor_audits",
      "foreignKey": "score_factor_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ScoreFactorAudit",
      "through": null
    },
    {
      "className": "CourseGroupCourse",
      "collectionName": "course_group_courses",
      "foreignKey": "score_factor_id",
      "name": "course_group_courses",
      "macro": "has_many",
      "resource_name": "CourseGroupCourse",
      "through": null
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "score_factor_id",
      "name": "courses",
      "macro": "has_many",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "ScoreFactor::Audit",
      "collectionName": "score_factor_audits",
      "foreignKey": "score_factor_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ScoreFactorAudit",
      "through": null
    },
    {
      "className": "ScoreFactor::Translation",
      "collectionName": null,
      "foreignKey": "score_factor_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "top_negative_score_factor_id",
      "name": "score_factor_check_ins_as_negative",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "top_positive_score_factor_id",
      "name": "score_factor_check_ins_as_positive",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "ScoreFactorGroupScoreFactor",
      "collectionName": "score_factor_group_score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor_group_score_factors",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroupScoreFactor",
      "through": null
    },
    {
      "className": "ScoreFactorGroup",
      "collectionName": "score_factor_groups",
      "foreignKey": "score_factor_group_id",
      "name": "score_factor_groups",
      "macro": "has_many",
      "resource_name": "ScoreFactorGroup",
      "through": "score_factor_group_score_factors"
    },
    {
      "className": "SurveyStepElementOptionScore",
      "collectionName": "survey_step_element_option_scores",
      "foreignKey": "score_factor_id",
      "name": "survey_step_element_option_scores",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionScore",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "score_factor_id",
      "name": "survey_step_elements",
      "macro": "has_many",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "ScoreFactor::Translation",
      "collectionName": null,
      "foreignKey": "score_factor_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "color",
      "column": {
        "default": null,
        "name": "color",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "icon",
      "column": {
        "default": null,
        "name": "icon",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "secondary_color",
      "column": {
        "default": null,
        "name": "secondary_color",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "score_factor",
  "primaryKey": "id"
}

/** Frontend model for ScoreFactor. */
export default class ScoreFactor extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  color() {
    return this.readAttributeUnderscore("color")
  }

  /** @returns {boolean} */
  hasColor() {
    const value = this.color()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  icon() {
    return this.readAttributeUnderscore("icon")
  }

  /** @returns {boolean} */
  hasIcon() {
    const value = this.icon()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  secondaryColor() {
    return this.readAttributeUnderscore("secondary_color")
  }

  /** @returns {boolean} */
  hasSecondaryColor() {
    const value = this.secondaryColor()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static moodDevelopmentChartData(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "mood_development_chart_data",
        collectionName: "score_factors",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  positiveNegativeData(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "positive_negative_data",
        primaryKey: this.primaryKey(),
        collectionName: "score_factors",
        type: "member"
      },
      commandArgs
    ))
  }
}
